import React from 'react'
import { TestimonialImage, TestimonialName, ProjectLink, ImageContainer, TestimonialProject, TestimonialsContainer, TestimonialText, TestimonialTextGroup, TestimonialTopGroup } from './testimonialsCardElements'




const TestimonialCard = (props) => {
    let projectComp = <TestimonialProject>Project: {props.project}</TestimonialProject>
    if(props.projectLink)
        projectComp = 
        (<div>
            <TestimonialProject >Project:  </TestimonialProject>
            <ProjectLink href={props.projectLink} target="_blank" >{props.project}</ProjectLink>
        </div>)
    return (
        <TestimonialsContainer >
            <TestimonialTopGroup>
                <ImageContainer>
                <TestimonialImage  src={props.headshot}/>
                </ImageContainer>
                <TestimonialTextGroup>
                    <TestimonialName>{props.name}</TestimonialName>
                    {projectComp}
                </TestimonialTextGroup>
            </TestimonialTopGroup>
            <TestimonialText>{props.testimonial}</TestimonialText>
        </TestimonialsContainer>
    )   
}

export default TestimonialCard
